export default __webpack_public_path__ + "static/media/airlockz-blk-banner-3.7a3279b1.jpg";